// Shared print / PDF stylesheet for the four public client-facing document
// pages: presentation (/p/:uuid), estimate + Quote (/o/:uuid),
// invoice (/i/:uuid) and PO (/po/:uuid).
//
// Seeded from PublicPresentationPage's original PRINT_STYLES block
// (2026-05-20) and hardened for color output.
//
// CEO 2026-07-24: "When downloading as a PDF (either a presentation,
// estimate, or SO) — make sure it's color, and a clean interface."
// The decisive rule is `print-color-adjust: exact` (and its -webkit-
// prefix): it tells the browser to render backgrounds + brand accents in
// print instead of dropping them to grayscale/white, which is the classic
// cause of a washed-out PDF.
//
// Chrome that is NOT part of the document (sticky nav, Download button,
// approve / pay bars, preview banners) is excluded from print via the
// shared `print:hidden` class that every page already puts on those
// elements. We deliberately do NOT blanket-hide <header>/<footer> here:
// the document pages use an inner <header> for the title block that MUST
// survive printing — the sticky top bar and the footer already carry
// `print:hidden` themselves.

export const DOCUMENT_PRINT_STYLES = `
  @media print {
    @page { margin: 0.5in; }
    html, body {
      background: #ffffff !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    main, main * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    /* Hide interactive chrome flagged by the shared print:hidden class
       (sticky bars, Download button, approve / pay bars, preview banners). */
    .print\\:hidden { display: none !important; }
    .print\\:pt-0 { padding-top: 0 !important; }
    .print\\:pb-0 { padding-bottom: 0 !important; }
    /* Page-break hygiene — never split a line-item card, table row, or list
       item across a page boundary. */
    li, tr { break-inside: avoid; }
    .rounded-3xl, .rounded-2xl, .rounded-xl { break-inside: avoid; }
    /* Full-bleed the document body for print. */
    main {
      padding: 0 !important;
      max-width: 100% !important;
    }
  }
`;

/**
 * Renders the shared document print stylesheet. Drop this near the top of a
 * public document page's root element (the way PublicPresentationPage did
 * with its local <style> block) so browser print-to-PDF keeps brand color.
 */
export function DocumentPrintStyles() {
  return <style>{DOCUMENT_PRINT_STYLES}</style>;
}
